import { render, staticRenderFns } from "./FirstTaxData.vue?vue&type=template&id=7175dca1&scoped=true"
import script from "./FirstTaxData.vue?vue&type=script&lang=js"
export * from "./FirstTaxData.vue?vue&type=script&lang=js"
import style0 from "./FirstTaxData.vue?vue&type=style&index=0&id=7175dca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7175dca1",
  null
  
)

export default component.exports